import { useEffect, useRef } from 'react';
import isEqual from 'react-fast-compare';
import { useSelector, useDispatch } from 'react-redux';
import { getThreadState } from '../../selectors';
import { streamIdChanged } from '../../actionCreators';
export function useThreadChanged(commentableItemId, commentableTypeId, parentId, enabled, maxDepthOverride) {
    if (enabled === void 0) { enabled = true; }
    var _a = useSelector(function (state) {
        return getThreadState(state, commentableTypeId, commentableItemId, parentId);
    }, isEqual), isInitialized = _a.isInitialized, order = _a.order, streamId = _a.streamId, maxDepth = _a.maxDepth;
    var dispatch = useDispatch();
    var previousStreamId = useRef();
    useEffect(function () {
        if (isInitialized || streamId === previousStreamId.current || !enabled) {
            return;
        }
        previousStreamId.current = streamId;
        dispatch(streamIdChanged({
            commentableItemId: commentableItemId,
            commentableTypeId: commentableTypeId,
            parentId: parentId,
            order: order,
            streamId: streamId,
            maxDepth: maxDepthOverride !== null && maxDepthOverride !== void 0 ? maxDepthOverride : maxDepth,
        }));
    }, [
        streamId,
        isInitialized,
        maxDepthOverride,
        commentableItemId,
        commentableTypeId,
        parentId,
        order,
        maxDepth,
        dispatch,
        enabled,
    ]);
}
//# sourceMappingURL=useThreadChanged.js.map